module.exports = __webpack_public_path__ + "media/tycho2t3_80_my.1e6c4242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_my.jpg
// module id = 1092
// module chunks = 0